export const COLORS = {
  white: '#ffffff',
  black: '#000000',
  audiRed: '#bb0a30',
  audiSilver: '#b3b3b3',
  audiWarmSilver: '#b6b1a9',
  audiDarkGray: '#4a4a4a',
  audiMidGray: '#4c4c4c',
  audiGrayFive: '#f2f2f2',
  highlightColor: '#f5f5f5',
  skeletonColor: '#d9d9d9',
  flashOfOrange: '#FFAA00',
  spaceInvader: '#0DA20D',
  grey5: '#f2f2f2',
  grey60: '#666666',
  grey90: '#262626',
  grey80: '#333333',
  redRibbon: '#EB0D3F',
  whiteOpacity: 'rgba(255, 255, 255, 0.15)',
};

type ColorKeys = keyof typeof COLORS;

export type Color = (typeof COLORS)[ColorKeys];

export const SIZING = {
  unit: (times: number): string => `${times * 8}px`,
};
